import { debounce, call, put, select } from 'redux-saga/effects';
import axios from '../axiosConfig';
import {
  getHotelRateCodeKeysResponse,
  getHotelRateCodeKeysRequest,
  getHotelRateCodeKeysFailure,
} from '../../slices/hotel';

function* getHotelRateCodeKeysWorker() {
  try {
    const hotelRateDescription = yield select((store) => store.hotel.hotelRateDescription);
    if (hotelRateDescription) {
      yield put(
        getHotelRateCodeKeysResponse({
          hotelRateDescription,
        }),
      );
    } else {
      const url = '/hotels/getHotelRateCodeKeys';
      const config = {
        method: 'GET',
        url,
        headers: {
          'Content-Type': 'application/json',
        },
      };
      const { data } = yield call(axios, config);
      if (data) {
        const { headerDescription, description } = data;
        yield put(
          getHotelRateCodeKeysResponse({
            hotelRateDescription: { headerDescription, description },
          }),
        );
      } else {
        yield put(getHotelRateCodeKeysResponse({}));
      }
    }
  } catch (error) {
    console.log({ error });
    yield put(getHotelRateCodeKeysFailure(''));
  }
}

function* getHotelKeyCodesWatcher() {
  yield debounce(125, getHotelRateCodeKeysRequest.toString(), getHotelRateCodeKeysWorker);
}

export default getHotelKeyCodesWatcher;
